import React, { useEffect, useState } from "react";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import './Chat.css'
import InfoBar from "./InfoBar";
import Messages from "./Messages";
import Input from "./Input";
import SideBar from "./SideBar";
import CryptoJS from "crypto-js";





// client socket
let socket;
const Chat = () => {

  const encrypt = (originalMessage) => {
    return CryptoJS.AES.encrypt(originalMessage, process.env.REACT_APP_SECRETKEY).toString();
}
  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [roomData, setRoomData] = useState([])

  const location = useLocation();
  const navigate = useNavigate();
  const ENDPOINT = "https://socionetapp.herokuapp.com/";

  useEffect(() => {
    const { name, room } = queryString.parse(location.search);
    setName(name);
    setRoom(room);
    
    // When socket(new user connection comes), we call up an event and pass the data that we need to give to the backend
    socket = io(ENDPOINT, { transports: ["websocket"] }); // initializing a new user socket
    console.log(socket)
    socket.emit("join", { name, room }, (error) => {
      if (error) {
        alert('Error')
      } 
    });

    

    // Below will be called before component unmounting, return statement in useEffect is used for unmounting but you need to reload the page hence when you close the chat instead of using Link use href
    
    return () => {
      socket.disconnect()

      // it will delete the current client instance
      socket.off();
    };
    // The second argument of useEffect tells us that we need to call useEffect again when the listed array elements change
  }, [ENDPOINT, location.search]);

  // This useEffect is for handling messages
  useEffect(() => {
    console.log('Inside the 2nd one')
    socket.on('message', (message) => {
      console.log('Second effect', message)
      setMessages([ ...messages, message ]);
    });
    
    socket.on('roomUsers', (data) => {
      setRoomData(data)
    })
    
    // socket.on("roomData", ({ users }) => {
    //   setUsers(users);
    // });
}, [messages]);
  
console.log(messages)
 //Function to send Messages
 const sendMessages = (event) => {
   // we don't want to reload the page on key press so need to write below
   event.preventDefault();

   if(message) {
     socket.emit('sendMessage', encrypt(message), () => setMessage(''));
     console.log("message event ke andr")
     // After executing above statement the on message event triggers inside useEffect
   }
  
 }

 console.log(messages)


 
  return (
    <>
     <div className = "outerContainer">
      
       <div className="container">
         <InfoBar room = {room}/>
         <Messages name = {name} messages = {messages} />
         <Input message = {message} setMessage = {setMessage} sendMessages={sendMessages} />
 
         </div>
         <div className="sideContainer">
       <SideBar roomData = {roomData}/>
       </div>
     </div>
  </>
  );
};

export default Chat;
